// manageLeaveSlice.js

import { createSlice } from "@reduxjs/toolkit";

const manageLeaveSlice = (name, defaultSortField = "createdAt", defaultSortOrder = "desc") => {
  const initialState = {
    pagination: { page: 0, pageSize: 15 },
    sortModel: [{ field: defaultSortField, sort: defaultSortOrder }],
    searchText: "",
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      setPagination: (state, action) => {
        state.pagination = action.payload;
      },
      setSortModel: (state, action) => {
        state.sortModel = action.payload;
      },
      setSearchText: (state, action) => {
        state.searchText = action.payload;
      },
      resetPage: state => {
      state.pagination.page = 0;
    },
      resetState: (state) => Object.assign(state, initialState),
    },
  });

  return slice;
};

// Create each tab slice like monitorSlice, etc.

export const managerTabSlice = manageLeaveSlice("managerTab", "package_Name", "desc");
export const hrTabSlice = manageLeaveSlice("hrTab", "package_Name", "desc");
export const wfhTabSlice = manageLeaveSlice("wfhTab", "package_Name", "desc");

// Export reducers together
export const manageLeaveReducers = {
  
  managerTab: managerTabSlice.reducer,
  hrTab: hrTabSlice.reducer,
  wfhTab: wfhTabSlice.reducer,
};



